import React from 'react';
import { Popover } from 'antd';
import cn from 'classnames';
import styles from './DspxPopover.module.scss';

const DspxPopover = ({ overlayClassName, arrow = true, ...props }) => {
  return (
    <Popover
      {...props}
      overlayClassName={cn(overlayClassName, {
        [styles.withoutArrow]: !arrow,
      })}
    />
  );
};

export default DspxPopover;
